<template>
    <div class="c333" v-loading="loading">
        <div class="w100_ fwb tac size24 mb15">{{ titil }}</div>
        <div :class="{ 'borderTopLeft': type == 1 }">

            <el-row v-for="item in templateList" :key="item.id" class="display-f">
                <el-col class="borderBox33"
                    :class="{ 'border33': kid.border, 'padding0': kid.child, 'left': !kid.border, 'borderTop': kid.borderTop, 'borderleft': kid.borderleft }"
                    v-for="(kid, ind) in item.children" :key="ind" :span="kid.span">
                    <span v-if="!kid.child">{{ kid.label }}</span>
                    <el-row v-for="(val, i) in kid.child" :key="i" :class="{ 'border33': val.border }"
                        class="borderBox33 flex flex1 w100_" :style="{ 'height': val.height }">{{ val.label }}</el-row>
                </el-col>

            </el-row>
        </div>

    </div>
</template>

<script>

import { ybPhyCodeList } from '@/utils/const';
import { MedicalInsurance } from '../medicalInsurance.js';
export default {
    components: {},
    props: {
        detailInfo: Object
    },
    data() {
        return {
            loading: false,//页面加载
            clrOptinsList: [],//清算中心
            clrTypeList: [],//清算类别
            deptId: this.$session.get('deptId'),//场馆id
            ybPhyCodeList: ybPhyCodeList,//医保门店对应code
            titil: '定点医药机构清算申请结算单',
            templateList: [],
            type: 2,//模板类型
        }
    },
    created() {
        this.getTypeList();
    },
    computed: {

        computedName() {
            return function (list, code) {
                return list.filter(val => val.code == code).length > 0 ? list.filter(val => val.code == code)[0].name : code
            }
        },
    },
    methods: {
        //获取code列表状态
        async getTypeList() {
            this.loading = true;
            const { clrTypeList, clrOptinsList } = await MedicalInsurance.getTypeList()
            //清算类别
            this.clrTypeList = clrTypeList
            this.clrOptinsList = clrOptinsList;
            this.createTemplat()
        },
        createTemplat() {
            let row = _.cloneDeep(this.detailInfo)
            // let comInfo = this.ybPhyCodeList.filter(val => val.deptId == this.deptId)[0];
            let comInfo = this.$session.get('deptInfo');
            let cleartypeName = this.computedName(this.clrTypeList, row.clrType);
            let clearCenteName = this.computedName(this.clrOptinsList, row.clrOptins);
            let nowTime = this.$moment().format("yyyy-MM-DD HH:mm:ss")
            if (row.clrType == '99915') {
                this.titil = '定点医药机构清算申请结算单(城职)'
            }
            if (row.clrType == '11' || row.clrType == 'N11') {
                this.type = 1;
                this.templateList = [
                    {
                        id: 1, children: [
                            { name: 'codeName', label: '医疗结构编码', span: 4, border: true },
                            { name: 'code', label: comInfo.ybDeptNum, span: 6, border: true },
                            { name: 'hopName', label: '医药机构名称（章）', span: 6, border: true },
                            { name: 'hop', label: comInfo.ybDeptName, span: 8, border: true },
                        ]
                    },
                    {
                        id: 2, children: [
                            { name: 'codeName', label: '清算分中心名称', span: 4, border: true },
                            { name: 'code', label: clearCenteName + '医疗保障中心', span: 6, border: true },
                            { name: 'hopName', label: '清算申请流水号', span: 6, border: true },
                            { name: 'hop', label: row.clrAppyEvtId, span: 8, border: true },

                        ]
                    },
                    {
                        id: 3, children: [
                            { name: 'codeName', label: '清算开始时间', span: 4, border: true },
                            { name: 'code', label: row.startDate, span: 6, border: true },
                            { name: 'hopName', label: '清算结束时间', span: 6, border: true },
                            { name: 'hop', label: row.endDate, span: 8, border: true },

                        ]
                    },
                    {
                        id: 4, children: [
                            { name: 'codeName', label: '清算类别', span: 4, border: true },
                            { name: 'code', label: '清算笔数', span: 4, border: true },
                            { name: 'hop', label: '医疗费用总额（元）', span: 4, border: true },
                            { name: 'hop', label: '个人账户申报总额（元）', span: 4, border: true },
                            { name: 'hopName', label: '大额基金支付', span: 4, border: true },
                            { name: 'hop', label: '基金申报总额（元）', span: 4, border: true },

                        ]
                    },
                    {
                        id: 5, children: [
                            { name: 'codeName', label: cleartypeName, span: 4, border: true },
                            { name: 'code', label: row.settleCount, span: 4, border: true },
                            { name: 'hopName', label: row.medfeeSumamt, span: 4, border: true },
                            { name: 'hop', label: row.acctPay, span: 4, border: true },
                            { name: 'hop', label: '0.00', span: 4, border: true },
                            { name: 'hop', label: row.fundPaySumamt, span: 4, border: true },

                        ]
                    },
                    {
                        id: 6, children: [
                            { name: 'codeName', label: '清算申请人：', span: 4, border: true },
                            { name: 'code', label: '', span: 8, border: true },
                            { name: 'hopName', label: '清算申请时间', span: 4, border: true },
                            { name: 'hop', label: nowTime, span: 8, border: true },

                        ]
                    },
                ]
            } else {
                this.type = 2
                this.templateList = [
                    {
                        id: 1, children: [
                            { name: 'codeName', label: '医疗结构编码', span: 6, border: false },
                            { name: 'code', label: comInfo.ybDeptNum, span: 6, border: false },
                            { name: 'hopName', label: '医药机构名称（章）', span: 6, border: false },
                            { name: 'hop', label: comInfo.ybDeptName, span: 6, border: false },

                        ]
                    },
                    {
                        id: 2, children: [
                            { name: 'codeName', label: '清算分中心名称', span: 6, border: false },
                            { name: 'code', label: clearCenteName+ '医疗保障中心', span: 6, border: false },
                            { name: 'hopName', label: '清算申请流水号', span: 6, border: false },
                            { name: 'hop', label: row.clrAppyEvtId, span: 6, border: false },

                        ]
                    },
                    {
                        id: 3, children: [
                            { name: 'codeName', label: '一级清算类别', span: 6, border: false },
                            { name: 'code', label: cleartypeName, span: 6, border: false },
                            { name: 'hopName', label: '清算期号', span: 6, border: false },
                            { name: 'hop', label: row.clearDate, span: 6, border: false },

                        ]
                    },
                    {
                        id: 4, children: [
                            { name: 'codeName', label: '二级清算类别', span: 4, border: true, borderTop: true, borderleft: true },
                            { name: 'code', label: '清算人次', span: 4, border: true, borderTop: true },
                            { name: 'hopName', label: '医疗费用总额', span: 4, border: true, borderTop: true },
                            { name: 'hop', label: '基金项', span: 6, border: true, borderTop: true },
                            { name: 'hop', label: '申请拨付金额', span: 6, border: true, borderTop: true },

                        ]
                    },
                    {
                        id: 5, children: [
                            { name: 'codeName', label: cleartypeName, span: 4, border: true, borderleft: true },
                            { name: 'code', label: row.settleCount, span: 4, border: true },
                            { name: 'hopName', label: '￥' + row.medfeeSumamt, span: 4, border: true },
                            {
                                name: 'hop', label: '基金项', span: 6, border: false, child: [
                                    { id: '5-1', name: '111', label: '城镇职工基本医疗保险个人基金账户', span: 12, border: true, height: '34px' },
                                    { id: '5-2', name: '111', label: '城镇职工基本医疗保险统筹基金', span: 12, border: true, height: '34px' },
                                    { id: '5-3', name: '111', label: '小计', span: 12, border: true, height: '20px' },
                                ]
                            },
                            {
                                name: 'hop', label: '申请拨付金额', span: 6, border: false, child: [
                                    { id: '5-4', name: '111', label: '￥' + row.acctPay, span: 12, border: true, height: '34px' },
                                    { id: '5-5', name: '111', label: '￥' + row.fundPaySumamt, span: 12, border: true, height: '34px' },
                                    { id: '5-6', name: '111', label: '￥' + row.acceptMoney, span: 12, border: true, height: '20px' },
                                ]
                            },

                        ]
                    },
                    {
                        id: 6, children: [
                            { name: 'codeName', label: '合计', span: 4, border: true, borderleft: true },
                            { name: 'code', label: row.settleCount, span: 4, border: true },
                            { name: 'hopName', label: '￥' + row.medfeeSumamt, span: 4, border: true },
                            { name: 'hop', label: '', span: 6, border: true },
                            { name: 'hop', label: '￥' + row.acceptMoney, span: 6, border: true },

                        ]
                    },
                    {
                        id: 7, children: [
                            { name: 'codeName', label: '清算申请人：', span: 6, border: false },
                            { name: 'code', label: '', span: 6, border: false },
                            { name: 'hopName', label: '清算申请时间：', span: 5, border: false },
                            { name: 'hop', label: nowTime, span: 7, border: false },

                        ]
                    },
                ]
            }
            this.loading = false
        },

    }
}
</script>

<style lang="less" scoped>
.borderBox33 {
    padding: 6px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.border33 {
    border-right: 1px solid #333;
    border-bottom: 1px solid #333;
    // border: 1px solid #333;
}

.borderTopLeft {
    border-left: 1px solid #333;
    border-top: 1px solid #333;
}

.borderNone {
    border: 1px solid transparent;
}

.borderTop {
    border-top: 1px solid #333;
}

.borderleft {
    border-left: 1px solid #333;
}

.padding0 {
    padding: 0px;
    display: flex;
    flex-direction: column;
}

.flex1 {
    flex: 1;
}

.left {
    justify-content: left !important;
}
</style>